<section class="chat-list-section" [class.d-none]="isCollapsed()">
	<chat-list-header />
	<div class="chat-items-wrapper nice-scroll colored-scroll-track">
		@if (isLoadingChats()) {
			<div>
				<mat-spinner diameter="40"></mat-spinner>
			</div>
		}
		@for (chat of chats(); track chat) {
			<div
				class="chat-item"
				[class.active]="chat.id === selectedChatId()"
				(click)="selectActiveChat(chat.id)"
			>
				<p>
					{{
						chat.buildingId ? chat.name : ('chatbot_new_chat' | translate) + ' ' + chat.id
					}}
				</p>
				<div class="chat-item-actions">
					<mat-icon
						svgIcon="delete"
						class="critical-icon"
						(click)="deleteChat(chat.id, $event)"
					/>
				</div>
			</div>
		}
	</div>
</section>
<div
	class="collapse-bar"
	[matTooltip]="
		(isCollapsed() ? 'chatbot_open_sidebar' : 'chatbot_close_sidebar') | translate
	"
	matTooltipPosition="right"
	(click)="collapseChatList()"
></div>
